export default "__VITE_ASSET__Cn5fUo9f__"